export default __webpack_public_path__ + "static/image_activities@2x-fcd6d0b16e93982162af0f6d223fcde4.jpg";